import { oidcSettings } from '../../configs/oidc';
import jwt from 'jsonwebtoken';
import UserService from 'src/api/users';

const state = {
  authMode: oidcSettings.authMode,
  currentUser: null,
  error: null,
  tosAccepted: false,
};
const getters = {
  authMode: (state) => {
    return state.authMode;
  },
  isAdmin: (state) => {
    if (state.currentUser) {
      return state.currentUser.role == 'ADMIN' ? true : false;
    }
    const token = sessionStorage.getItem('token');
    if (token) {
      const decoded = jwt.decode(token);
      return decoded.role == 'ADMIN' ? true : false;
    }
    return false;
  },
  isOrgAdmin: (state) => {
    if (state.currentUser) {
      return state.currentUser.role == 'ORG_ADMIN' ? true : false;
    }
    const token = sessionStorage.getItem('token');
    if (token) {
      const decoded = jwt.decode(token);
      return decoded.role == 'ORG_ADMIN' ? true : false;
    }
    return false;
  },
  isLoggedIn: (state) => {
    return sessionStorage.getItem('token') ? true : false;
  },
  currentUser: (state) => {
    return state.currentUser;
  },
  error: (state) => {
    return state.error;
  },
  tosAccepted: (state) => state.tosAccepted,
};
const actions = {
  async setCurrentUser({ commit }, payload) {
    commit('setCurrentUser', payload);
  },
  async getCurrentUser({ commit, dispatch }, payload) {
    const token = sessionStorage.getItem('token');
    const decoded = jwt.decode(token);
    if (decoded) {
      const response = await UserService.getUser(decoded.uid, token);

      if (!response.success) {
        commit('setError', response.message);
        return;
      }
      // get org details for current user - needed for license checks
      const orgId = response.data.organization_id;
      await dispatch('users/getOrgDetails', orgId, {
        root: true,
      });
      // set user data in sessionStorage
      sessionStorage.setItem('user', JSON.stringify(response.data));
      for (const key in response.data) {
        if (key != 'password') sessionStorage.setItem(key, response.data[key]);
      }
      commit('setCurrentUser', response.data);
      return response.data;
    }
  },
  async setTosAccepted({ commit, state, dispatch }) {
    // Set tos acceptance in state and sessionStorage
    sessionStorage.setItem('sessionTosAccepted', true);
    commit('setTosAccepted');
    // Update user in db if we haven't already
    if (state.currentUser && !state.currentUser.tos_accepted) {
      const response = await dispatch(
        'users/updateUser',
        {
          uid: state.currentUser.uid,
          payload: { tos_accepted: true },
        },
        { root: true }
      );
      // If successful, update the current user in state
      if (response && response.length > 0 && response[0].tos_accepted) {
        await dispatch('getCurrentUser');
      }
    }
  },
};
const mutations = {
  setCurrentUser(state, payload) {
    if (payload && payload.username) {
      sessionStorage.setItem('username', payload.username);
    }
    state.currentUser = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setTosAccepted(state) {
    state.tosAccepted = true;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
